import * as React from 'react';
import "./styles.css";

export interface SidebarDetailProps {
    localizedSidebarNavTitles: string[];
    shouldUpdateNavIndex?: () => boolean;
    onSidebarNavItemClicked?: (clickedNavIndex: number) => void;
    initialActiveIndex?: number;
    onlyChildToRender?: JSX.Element;
}

interface SidebarDetailState {
    activeNavIndex: number;
}

//
// A sidebar-detail view. A sidebar nav is on the left side, body content on the right side.
//
// Pass the list of nav titles in the props; the bodies of the different nav endpoints are
// children of the component.
//
// The nav titles are 1-1 correlated to the children bodies by their index order.
//
export class SidebarDetail extends React.PureComponent<SidebarDetailProps, SidebarDetailState> {
    public constructor(props: SidebarDetailProps) {
        super(props);

        this.state = {
            activeNavIndex: this.props.initialActiveIndex ?? 0
        };
    }

    // ===============================================================================

    public render() {
        const activeChildren = this.props.onlyChildToRender ?
            this.props.onlyChildToRender :
            React.Children
                .toArray(this.props.children)
                .filter((child, index) => index === this.state.activeNavIndex);

        return (
            <div className="sidebar-detail">
                <div className="sidebar">
                    <nav>
                        <ul>
                            {this.props.localizedSidebarNavTitles.map((localizedTitle, navIndex) => (
                                <li key={navIndex} className={(this.state.activeNavIndex === navIndex ? "active" : "")} onClick={e => this.sideBarNavItem_click(navIndex)}>{localizedTitle}</li>
                                ))}
                        </ul>
                    </nav>
                </div>
                <div className="detail">
                    {activeChildren}
                </div>
            </div>
        );
    }

    // ===============================================================================

    private sideBarNavItem_click = (navIndex: number) => {
        if (this.props.shouldUpdateNavIndex && (!this.props.shouldUpdateNavIndex())) {
            return;
        }

        this.setState({
            activeNavIndex: navIndex
        })

        if (this.props.onSidebarNavItemClicked) {
            this.props.onSidebarNavItemClicked(navIndex);
        }
    };
}